import { Options, Vue } from "vue-class-component";
import Toggle from "@vueform/toggle";

import { ErrorType } from "@/interfaces/error";
import { Product } from "@/domain/product.model";
import i18n from "@/translation/i18n";
const { t } = i18n.global;

@Options({
  name: "platform-new",
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class PlatformNew extends Vue {
  public id: string;
  public module = "";
  public errorMessage = "";
  public errors: ErrorType = {};
  public hasError = false;
  public row = {
    id_product: "",
    name: "",
    code_video_external: "",
    url: "",
    enabled: true,
  };

  public products = {
    description: "",
  };

  public created(): void {
    this.$store
      .dispatch("product/get", this.id)
      .then((res: Product) => {
        if (res && res.id) {
          this.products = res;
        } else {
          this.errorMessage = t("labels.noDataAvailable");
        }
      })
      .catch(() => {
        this.errorMessage = t("labels.noDataAvailable");
      });
  }

  public goBack() {
    this.$router.push(`/product/${this.id}`);
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.name) {
      this.errors.name = t("labels.errors");
      this.hasError = true;
    }

    if (!this.row.url) {
      this.errors.url = t("labels.errors");
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      this.$store
        .dispatch("platform/insert", {
          id_product: parseInt(this.id),
          name: this.row.name,
          code_video_external: this.row.code_video_external,
          url: this.row.url,
          enabled: this.row.enabled,
        })
        .then(() => {
          this.$router.push(`/product/${this.id}`);
        })
        .catch(() => {
          this.errorMessage = t("labels.errorMessage");
        });
    }
  }
}
